const router = {
  path: '/markup/person',
  name: 'MarkupPerson',
  meta: { title: '自然人补录', type: 'user' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/markup/person/card',
      name: 'MarkupPersonCard',
      meta: { title: '车卡信息', type: 'user' },
      component: () => import('@/views/markup/person/card')
    },
    {
      path: '/markup/person/base',
      name: 'MarkupPersonBase',
      meta: { title: '身份信息', type: 'user' },
      component: () => import('@/views/markup/person/base')
    },
    {
      path: '/markup/person/idcard',
      name: 'MarkupPersonIdcard',
      meta: { title: '证件信息', type: 'user' },
      component: () => import('@/views/markup/person/idcard')
    },
    {
      path: '/markup/person/paper',
      name: 'MarkupPersonPaper',
      meta: { title: '证件信息', type: 'user' },
      component: () => import('@/views/markup/person/paper')
    },
    {
      path: '/markup/person/file',
      name: 'MarkupPersonFile',
      meta: { title: '文件信息', type: 'user' },
      component: () => import('@/views/markup/person/file')
    },
    {
      path: '/markup/person/notification',
      name: 'MarkupPersonNotification',
      // meta: { title: '责任告知书', type: 'user' },
      meta: { title: '实名认证隐私政策与责任告知书', type: 'user' },
      component: () => import('@/views/markup/person/notification')
    },
    {
      path: '/markup/person/agreement',
      name: 'MarkupPersonAgreement',
      meta: { title: '入网协议', type: 'user' },
      component: () => import('@/views/markup/person/agreement')
    },
    {
      path: '/markup/person/result',
      name: 'MarkupPersonResult',
      meta: { title: '校验结果', type: 'user' },
      component: () => import('@/views/markup/person/result')
    }
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/person-markup.js